export const mdastTypes = {
    tableCellColspanWithRight: 'tableCellColspanWithRight',
    tableCellColspanWithLeft: 'tableCellColspanWithLeft',
    tableCellRowspan: 'tableCellRowspan',
};
